export default __webpack_public_path__ + "static/media/support_blue.9dbe6558.png";